export enum ActionDeleteGroup {
    title = 'CHAT.delete_this_group_chat',
    description = 'CHAT.are_you_sure_you_want_to_delete_this_group_chat',
    button = 'CHAT.yes_delete'
}

export enum ActionTextLeaveGrup {
    title = 'CHAT.leave_this_chat',
    description = 'CHAT.are_you_sure_you_want_to_exit_from_this_chat_group',
    buttonText = 'CHAT.yes_exit'

}

export enum ActionDeleteSingleChat {
    title = 'CHAT.delete_chat',
    description = 'CHAT.are_you_sure_you_wish_to_delete_this_chat',
    buttonText = 'GENERAL.delete'
}

export enum ShareEntitiesEnums {
  review = 'review',
  lysts = 'lyst',
  lyst_item = 'lyst_item',
  profile = 'profile',
  post = 'post'
}
